import userPermissionsEnum from '@enums/user-permissions';
import { useContextStore } from '@/stores/context';
import { computed } from 'vue';

export function usePermission() {
  const context = useContextStore();
  const userPermissions = Object.freeze(userPermissionsEnum);
  const computedUserPermissions = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(userPermissions)) {
    computedUserPermissions[key] = computed(() => {
      return context.hasPermission(userPermissions[key]);
    });
  }

  return { ...computedUserPermissions };
}
